import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const CreatePolicyService = (data: any) => {
  return HTTP_CLIENT.post(`${Endpoint.policy.createPolicy}`, data);
};

const GetPolicy = (policyType: string) => {
  return HTTP_CLIENT.get(`${Endpoint.policy.getPolicy}/${policyType}`);
};

const UpdatePolicyService = (policyId: number, data: any) => {
  return HTTP_CLIENT.patch(
    `${Endpoint.policy.updatePolicy}/${policyId}`,
    data,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

export { CreatePolicyService, UpdatePolicyService, GetPolicy };
